import React, { Fragment } from "react";
import {
  Container,
  Icon,
  Popup,
  Segment
} from "semantic-ui-react";
import { QuickLinks } from "../constants";

/**
 * @author
 * @function QuickLink
 **/

const QuickLink = props => {

  const redirectWithQuickLink = (value) => {
      window.location.href = value
  }
  return (
    <Fragment>
      <Container>
      <Segment>
      <div
        style={{
          //   justifyContent: "space-between",
          //   display: "flex",
          //   flexDirection: "column",
          //   alignContent : "center",
          //   margin : "auto",
          textAlign: "center",
          padding: "30%"
        }}
      >
        {QuickLinks.map(icon => {
          return (
            <Popup
              trigger={
                <Icon
                  className = "quicklinks"
                  style={{ marginBottom: "20px", cursor: "pointer" }}
                  size="huge"
                  name={icon.name}
                  onClick ={() => redirectWithQuickLink(icon.value)}
                />
              }
              content={icon.value}
              basic
            />
          );
        })}
      </div>
      </Segment></Container>
    </Fragment>
  );
};

export default QuickLink;
